import { Box, Button, Card, InlineStack,Badge, BlockStack } from '@shopify/polaris';
import React from 'react';

const SourcingQuotaList = ({sourcingQuotaList,handleQuotaBuy})=> {
    return (
        <Box>
            <Box className="new_sub_module_title">Sourcing Quota</Box>
            <Box className="new_sub_sorcing_quota_list">
                {sourcingQuotaList.map((item,ind)=><Box key={ind}>
                    <Card>
                       <BlockStack gap={200}>
                        <Box><Badge tone="success">{item.num} {item.badge}</Badge></Box>
                        <Box>
                            <InlineStack gap={100} blockAlign='baseline'>
                            <Box style={{fontSize:20,fontWeight:650}}>${item.money}</Box>
                            <span style={{color:'rgba(118, 118, 118, 1)'}}>USD</span>
                            </InlineStack>
                        </Box>
                        <Box>${item.money / item.num} {item.desc}</Box>
                        <Box><Button loading={item.loading} disabled={item.disabled} onClick={()=>handleQuotaBuy(item.key,0)}>{item.button}</Button></Box>
                        </BlockStack>
                    </Card>
                </Box>)}
            </Box>
        </Box>
    );
}

export default SourcingQuotaList;
